var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-list-wrap"},[_c('dg-header',{attrs:{"showBack":true,"title":"订单列表"}}),_c('order-tabbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }